import * as React from 'react';
var NavContext = /*#__PURE__*/React.createContext(null);
NavContext.displayName = 'NavContext';
export default NavContext;